import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { AnimalData } from '../../../components/tree+two/animalData'; 
import { TreeTwo } from '../../../components/tree+two/map';

const AnimalDataPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                    <title>Свод данных</title>
                </Helmet>
            <AnimalData/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default AnimalDataPage
